// alert(window.screen.height)
//
// 全局进度
// const loading = this.$loading(this.espConstant.loadingType);
// loading.close();


let date = new Date();
let y = 1900 + date.getYear()
let m = '0' + (date.getMonth() + 1)
let d = '0' + date.getDate()
let espDateNow = y + '-' + m.substring(m.length - 2, m.length) + '-' + d.substring(d.length - 2, d.length);

let c_month = "01";
if (date.getMonth() + 1 < 10) {
  c_month = "0" + (date.getMonth() + 1);
} else {
  c_month = "" + (date.getMonth() + 1);
}

let loadingType = {
  lock: true,
  text: "Loading",
  spinner: "el-icon-loading",
  background: "rgba(0, 0, 0, 0.3)"
}

var xhWidth = '75px';    //表格序号列宽度
var handlerWidth = '200px'   //表格操作列宽度

// let baiduKey = "mjCjzvrKYoEzYpRHmYgoVkfCEDw6M2Xj";

export default {
  esp_page_size: 50,
  esp_page_size_group: [10, 50, 100, 300, 500],
  loadingType: loadingType,
  esp_data_now: espDateNow,
  esp_xh_width: xhWidth,
  esp_handler_width: handlerWidth
}



// WEBPACK FOOTER //
// ./src/utils/constant.js